import EditEvent from '../components/EditEvent';
import PageLayout from '../components/pageLayout';

function EditEventPage() {
    return (
        <PageLayout children={<EditEvent />} />
    );
}

export default EditEventPage;
